import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetExpectedProjectImpact = createAsyncThunk(
  "ExpectedProjectImpact/GetExpectedProjectImpact",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PI_ExpectedProjectImpactOnTargetGroup/GetExpectedProjectImpact",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result.result; // Assuming response has a "data" field
      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateExpectedProjectImpact = createAsyncThunk(
  "ExpectedProjectImpact/ValidateExpectedProjectImpact",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PI_ExpectedProjectImpactOnTargetGroup/ValidateExpectedImpactOfTheProject",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });

        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ExpectedProjectImpact = createSlice({
  name: "ExpectedProjectImpact",
  initialState: {
    ExpectedProjectImpact: {},
    loadingGetExpectedProjectImpact: false,
    errorGetExpectedProjectImpact: null,

    ExpectedProjectImpactValidate: [],
    loadingExpectedProjectImpactValidate: false,
    errorExpectedProjectImpactValidate: null,
  },
  reducers: {
    SetExpectedProjectImpact: (state, action) => {
      state.ExpectedProjectImpact = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetExpectedProjectImpact.pending, (state, action) => {
        state.loadingGetExpectedProjectImpact = true;
        state.ExpectedProjectImpact = action.payload;
        state.errorGetExpectedProjectImpact = null;
      })
      .addCase(GetExpectedProjectImpact.fulfilled, (state, action) => {
        state.loadingGetExpectedProjectImpact = false;
        state.ExpectedProjectImpact = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetExpectedProjectImpact.rejected, (state, action) => {
        state.loadingGetExpectedProjectImpact = false;
        state.errorExpectedProjectImpactValidate = action.payload;
      })



      .addCase(ValidateExpectedProjectImpact.pending, (state, action) => {
        state.loadingExpectedProjectImpactValidate = true;
        state.ExpectedProjectImpactValidate = action.payload;
        state.errorProjectInformationValidate = null;
      })
      .addCase(ValidateExpectedProjectImpact.fulfilled, (state, action) => {
        state.loadingExpectedProjectImpactValidate = false;
        state.ExpectedProjectImpactValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateExpectedProjectImpact.rejected, (state, action) => {
        state.loadingExpectedProjectImpactValidate = false;
        state.errorExpectedProjectImpactValidate = action.payload;
      });
  },
});
export const { SetExpectedProjectImpact } = ExpectedProjectImpact.actions;

export default ExpectedProjectImpact.reducer;
